import React from "react";

const AboutUs = ({}) => {
  return (
    <>
      <p className="text-dark h5 mb-4">About Us</p>

      <p>
        Urgidoctor is a leading telehealth and mobile application that allows
        users to access care remotely, with their own health care Provider or
        available on-call Physicians. For the Providers it is an easy way to
        connect with their own patients during and after hours. It is also good
        application to replace answering service.
      </p>
      <p>
        {" "}
        User can also seek second opinions and look for providers providing pro
        bono services
      </p>
      <p>
        Healthcare should be fast, simple and easy. Urgidoctor makes it easy to
        visit Physicians and Healthcare Providers within minutes through our
        mobile app. Get access to quality health care without ever living home,
        your office or wherever you are.
      </p>
    </>
  );
};

export default AboutUs;
